import Vue from 'vue'
import axios from 'axios'
import authApi from '@/services/auth.js'
import api from '@/services/api.js'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth_status: '',
    access_token: sessionStorage.getItem('access_token') || '',
    access_token_expiration: sessionStorage.getItem('access_token_expiration') || '',
    refresh_token: sessionStorage.getItem('refresh_token') || '',
    refresh_token_expiration: sessionStorage.getItem('refresh_token_expiration') || '',
    token_type: sessionStorage.getItem('token_type') || '',
    user_id: sessionStorage.getItem('user_id') || '',
    first_name: sessionStorage.getItem('first_name') || '',
    last_name: sessionStorage.getItem('last_name') || '',
    birth_name: sessionStorage.getItem('birth_name') || '',
    gender: sessionStorage.getItem('gender') || '',
    birth_date: sessionStorage.getItem('birth_date') || '',
    birthPlace: sessionStorage.getItem('birthPlace') || '',
    email: sessionStorage.getItem('email') || '',
    password: sessionStorage.getItem('password') || '',
    completedTraining: sessionStorage.getItem('completed_training') || false,
    displayDcCertificateLink: sessionStorage.getItem('display_dc_certificate_link') || false,
    displayDcplusCertificateLink: sessionStorage.getItem('display_dcplus_certificate_link') || false,
    displayedSuccessModal: sessionStorage.getItem('displayed_success_modal') || false,
    showPracticalExercise: sessionStorage.getItem('show_practical_exercise') || true,
    showDcModules: sessionStorage.getItem('show_dc_modules') || true,
    showDcplusModules: sessionStorage.getItem('show_dcplus_modules') || true,
    nom_popup: sessionStorage.getItem('nom_popup') || false,
    naissance_popup: sessionStorage.getItem('naissance_popup') || false,
    is_plus: sessionStorage.getItem('is_plus') || null,
    nb_modules_completed: sessionStorage.getItem('nb_modules_completed') || 0,
    date_accord_sondage: sessionStorage.getItem('date_accord_sondage') || null,
    accord_sondage: sessionStorage.getItem('accord_sondage') || null,
    rappel_sondage: sessionStorage.getItem('rappel_sondage') || null,
    checked_identity: sessionStorage.getItem('checked_identity') || false,
  },
  getters: {
    isAuthenticated: (state) => () => {
      return state.access_token? true : false
    },
    getFullName: (state) => () => {
      return `${state.last_name} ${state.first_name}`
    },
    getUserId: (state) => () => {
      return state.user_id
    },
    isTokenValid: (state) => () => {
      return (state.access_token_expiration && state.access_token_expiration > parseInt(Date.now()/1000))? true : false
    },
    getTokenValidityRemaining: (state) => () => {
      return state.access_token_expiration - parseInt(Date.now()/1000)
    },
    isRefreshTokenValid: (state) => () => {
      return (state.refresh_token_expiration && state.refresh_token_expiration > parseInt(Date.now()/1000))? true : false
    },
    getToken: (state) => () => {
      return state.token_type+' '+state.access_token
    },
    getUser: (state) => () => {
      return {
        gender: state.gender,
        first_name: state.first_name,
        last_name: state.last_name,
        birth_name: state.birth_name,
        birth_date: state.birth_date,
        birthPlace: state.birthPlace,
        email: state.email,
        password: state.password,
      }
    },
    getEmail: (state) => () => {
      return state.email
    },
    getPassword: (state) => () => {
      return state.password
    },
    getCompletedTraining: (state) => () => {
      return state.completedTraining
    },
    getDisplayDcCertificateLink: (state) => () => {
      return (state.displayDcCertificateLink=="true" || state.displayDcCertificateLink==true)
    },
    getDisplayDcplusCertificateLink: (state) => () => {
      return state.displayDcplusCertificateLink
    },
    getDisplayedSuccessModal: (state) => () => {
      return state.displayedSuccessModal
    },
    getShowPracticalExercise: (state) => () => {
      return state.showPracticalExercise
    },
    getShowDcModules: (state) => () => {
      return (state.showDcModules == true || state.showDcModules == "true")
    },
    getShowDcplusModules: (state) => () => {
      return (state.showDcplusModules == true || state.showDcplusModules == "true")
    },
    getIsPlus: (state) => () => {
      return (state.is_plus=="true" || state.is_plus==true)
    },
    getCheckIdentityStep: (state) => () => {
      return (state.nom_popup=="true") ? "full_name" : (state.naissance_popup=="true") ? "birth" : null
    },
    getNomPopup: (state) => () => {
      return state.nom_popup;
    },
    getNaissancePopup: (state) => () => {
      return state.naissance_popup;
    },
    getNbModulesCompleted: (state) => () => {
      return state.nb_modules_completed;
    },
    getDateAccordSondage: (state) => () => {
      return state.date_accord_sondage;
    },
    getAccordSondage: (state) => () => {
      return (state.accord_sondage == true || state.accord_sondage == "true") ? 1 : (state.accord_sondage == false || state.accord_sondage == "false") ? 0 : null;
    },
    getCheckedIdentity: (state) => () => {
      return (state.checked_identity == true || state.checked_identity == "true") ? true : false;
    },
  },
  mutations: {
    AUTH_REQUEST: state => {
      state.auth_status = 'loading'
    },
    AUTH_SUCCESS: state => {
      state.auth_status = 'success'
    },
    AUTH_ERROR: state => {
      state.auth_status = 'error'
    },
    AUTH_LOGOUT: state => {
      state.auth_status = ''
    },
    UPDATE_ACCESS_TOKEN: state => {
      state.access_token = sessionStorage.getItem('access_token')
    },
    UPDATE_ACCESS_TOKEN_EXPIRATION: state => {
      state.access_token_expiration = sessionStorage.getItem('access_token_expiration')
    },
    UPDATE_REFRESH_TOKEN: state => {
      state.refresh_token = sessionStorage.getItem('refresh_token')
    },
    UPDATE_REFRESH_TOKEN_EXPIRATION: state => {
      state.refresh_token_expiration = sessionStorage.getItem('refresh_token_expiration')
    },
    UPDATE_TOKEN_TYPE: state => {
      state.token_type = sessionStorage.getItem('token_type')
    },
    UPDATE_EMAIL: (state, email) => {
      state.email = email
    },
    UPDATE_PASSWORD: (state, password) => {
      state.password = password
    },
    UPDATE_COMPLETED_TRAINING: state => {
      state.completedTraining = true
    },
    UPDATE_DISPLAY_DC_CERTIFICATE_LINK: state => {
      state.displayDcCertificateLink = true
    },
    UPDATE_DISPLAY_DCPLUS_CERTIFICATE_LINK: state => {
      state.displayDcplusCertificateLink = true
    },
    UPDATE_DISPLAYED_SUCCESS_MODAL: state => {
      state.displayedSuccessModal = true
    },
    SHOW_PRACTICAL_EXERCISE: state => {
      state.showPracticalExercise = true
    },
    HIDE_PRACTICAL_EXERCISE: state => {
      state.showPracticalExercise = false
    },
    SHOW_DC_MODULES: state => {
      state.showDcModules = true
    },
    HIDE_DC_MODULES: state => {
      state.showDcModules = false
    },
    SHOW_DCPLUS_MODULES: state => {
      state.showDcplusModules = true
    },
    HIDE_DCPLUS_MODULES: state => {
      state.showDcplusModules = false
    },
    SET_PLUS_USER: state => {
      state.is_plus = true
    },
    SET_CLASSIC_USER: state => {
      state.is_plus = false
    },
    UPDATE_NOM_POPUP: state => {
      state.nom_popup = false
    },
    UPDATE_NAISSANCE_POPUP: state => {
      state.naissance_popup = false
    },
    SET_GENDER_FEMALE: state => {
      state.gender = "FEMALE"
    },
    SET_GENDER_MALE: state => {
      state.gender = "MALE"
    },
    SET_FIRST_NAME: (state, first_name) => {
      state.first_name = first_name
    },
    SET_LAST_NAME: (state, last_name) => {
      state.last_name = last_name
    },
    SET_BIRTH_NAME: (state, birth_name) => {
      state.birth_name = birth_name
    },
    SET_BIRTH_DATE: (state, birth_date) => {
      state.birth_date = birth_date.date
    },
    SET_BIRTHPLACE: (state, birth_place) => {
      state.birthPlace = birth_place
    },
    UPDATE_NB_MODULES_COMPLETED: (state, nbModules) => {
      state.nb_modules_completed = nbModules
    },
    SET_SURVEY_DISAGREEMENT: (state) => {
      state.accord_sondage = false
    },
    SET_SURVEY_AGREEMENT: (state) => {
      state.accord_sondage = true
    },
    SET_SURVEY_AGREEMENT_DATE: (state, agreementDate) => {
      state.date_accord_sondage = agreementDate
    },
  },
  actions: {
    auth_request: ({ commit, state }, user) => {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST');
        authApi.post('', {
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          grant_type: "password",
          username: user.username,
          password: user.password
        })
        .then(resp=> {
          sessionStorage.clear()
          sessionStorage.setItem('access_token', resp.data.access_token)
          sessionStorage.setItem('access_token_expiration', parseInt(Date.now()/1000 + resp.data.expires_in))
          sessionStorage.setItem('refresh_token', resp.data.refresh_token)
          sessionStorage.setItem('refresh_token_expiration', parseInt(Date.now()/1000 + resp.data.refresh_token_lifetime))
          sessionStorage.setItem('token_type', resp.data.token_type[0].toUpperCase() + resp.data.token_type.slice(1))
          sessionStorage.setItem('user_id', resp.data.user.id)
          sessionStorage.setItem('gender', resp.data.user.gender)
          sessionStorage.setItem('first_name', resp.data.user.first_name)
          sessionStorage.setItem('last_name', resp.data.user.last_name)
          sessionStorage.setItem('birth_name', resp.data.user.birth_name)
          sessionStorage.setItem('birth_date', resp.data.user.birth_date.date)
          sessionStorage.setItem('birthPlace', resp.data.user.birthPlace)
          sessionStorage.setItem('nom_popup', resp.data.user.nom_popup)
          sessionStorage.setItem('naissance_popup', resp.data.user.naissance_popup)
          let date_accord_sondage = (resp.data.user.date_accord_sondage === null)? null : resp.data.user.date_accord_sondage.date
          sessionStorage.setItem('date_accord_sondage', date_accord_sondage)
          sessionStorage.setItem('accord_sondage', resp.data.user.accord_sondage)
          sessionStorage.setItem('rappel_sondage', resp.data.user.rappel_sondage)
          sessionStorage.setItem('email', (resp.data.user.email != null ? resp.data.user.email : ''))
          let checkedIdentity = (resp.data.user.nom_popup == false && resp.data.user.naissance_popup == false) ? true : false
          sessionStorage.setItem('checked_identity', checkedIdentity)

          api.defaults.headers.common['Authorization'] = `${state.token_type} ${state.access_token}`
          commit('AUTH_SUCCESS')
          resolve(resp);
        })
        .catch(err => {
          commit('AUTH_ERROR')
          sessionStorage.clear()
          reject(err.response);
        })
      })
    },
    async auth_refresh_token ({commit, state}) {
      commit('AUTH_REQUEST');
      await api.get('/user/logout').then(async ()=> {
         await authApi.post('', {
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          grant_type: "refresh_token",
          refresh_token: state.refresh_token
        })
        .then(resp=> {
          sessionStorage.setItem('access_token', resp.data.access_token)
          sessionStorage.setItem('access_token_expiration', parseInt(Date.now()/1000 + resp.data.expires_in))
          sessionStorage.setItem('refresh_token', resp.data.refresh_token)
          sessionStorage.setItem('refresh_token_expiration', parseInt(Date.now()/1000 + resp.data.refresh_token_lifetime))
          sessionStorage.setItem('token_type', resp.data.token_type[0].toUpperCase() + resp.data.token_type.slice(1))
          commit('UPDATE_ACCESS_TOKEN')
          commit('UPDATE_ACCESS_TOKEN_EXPIRATION')
          commit('UPDATE_REFRESH_TOKEN')
          commit('UPDATE_REFRESH_TOKEN_EXPIRATION')
          commit('UPDATE_TOKEN_TYPE')
          api.defaults.headers.common['Authorization'] = `${state.token_type} ${state.access_token}`
          commit('AUTH_SUCCESS')
        })
        .catch(err => {
          commit('AUTH_LOGOUT')
          console.log(err.response)
        })
      })
      .catch(err => {
        commit('AUTH_LOGOUT')
        console.log(err.response)
      })
    },
    auth_logout: ({ commit }) => {
      return new Promise((resolve) => {
        commit('AUTH_LOGOUT');
        api.get('/user/logout')
        .then(()=> {
          sessionStorage.clear()
          axios.defaults.headers.common['Authorization'] = null
          location.reload()
        })
        .catch(()=> {
          sessionStorage.clear()
          axios.defaults.headers.common['Authorization'] = null
          location.reload()
        })
        resolve();
      })
    },
    update_email: ({ commit, state }, email) => {
        if (email != null && state.email != email) {
          sessionStorage.setItem('email', email)
          commit('UPDATE_EMAIL', email);
        }
    },
    update_password: ({ commit, state }, password) => {
        if (password != null && state.password != password) {
          sessionStorage.setItem('password', password)
          commit('UPDATE_PASSWORD', password);
        }
    },
    set_completed_training: ({commit, state}, modules) => {
      if(state.completedTraining==false && state.email!="" && state.email!=null && state.password=="encrypt") {
        let completed = true
        for (let module of Object.entries(modules)) {
          if(module[1].completion<100) {
            completed = false
            return
          }
        }
        if(completed == true) {
          sessionStorage.setItem('completed_training', true)
          commit('UPDATE_COMPLETED_TRAINING')
        }
      }
    },
    set_display_dc_certificate_link: ({commit, state}, modules) => {
      if(state.displayDcCertificateLink==false) {
        let display = false
        for (let module of Object.entries(modules)) {
          if(module[1].completion==100) {
            display = true
            break
          }
        }
        if(display == true) {
          sessionStorage.setItem('display_dc_certificate_link', true)
          commit('UPDATE_DISPLAY_DC_CERTIFICATE_LINK')
        }
      }
    },
    set_display_dcplus_certificate_link: ({commit, state}, modules) => {
      if(state.displayDcplusCertificateLink==false) {
        let display = false
        for (let module of Object.entries(modules)) {
          if(module[1].completion==100) {
            display = true
            break
          }
        }
        if(display == true) {
          sessionStorage.setItem('display_dcplus_certificate_link', true)
          commit('UPDATE_DISPLAY_DCPLUS_CERTIFICATE_LINK')
        }
      }
    },
    set_displayed_success_modal: ({commit, state}) => {
      if(state.displayedSuccessModal!=true) {
        sessionStorage.setItem('displayed_success_modal', true)
        commit('UPDATE_DISPLAYED_SUCCESS_MODAL')
      }
    },
    set_show_practical_exercise: ({commit}, data) => {
      if(data==true) {
        sessionStorage.setItem('show_practical_exercise', true)
        commit('SHOW_PRACTICAL_EXERCISE')
      }
      else if (data==false) {
        sessionStorage.setItem('show_practical_exercise', false)
        commit('HIDE_PRACTICAL_EXERCISE')
      }
    },
    set_show_dc_modules: ({commit}, data) => {
      if(data==true) {
        sessionStorage.setItem('show_dc_modules', true)
        commit('SHOW_DC_MODULES')
      }
      else if (data==false) {
        sessionStorage.setItem('show_dc_modules', false)
        commit('HIDE_DC_MODULES')
      }
    },
    set_show_dcplus_modules: ({commit}, data) => {
      if(data==true) {
        sessionStorage.setItem('show_dcplus_modules', true)
        commit('SHOW_DCPLUS_MODULES')
      }
      else if (data==false) {
        sessionStorage.setItem('show_dcplus_modules', false)
        commit('HIDE_DCPLUS_MODULES')
      }
    },
    update_plus_status: ({commit}, isPlus) => {
      if(isPlus == true) {
        sessionStorage.setItem('is_plus', true)
        commit('SET_PLUS_USER')
      }
      else {
        sessionStorage.setItem('is_plus', false)
        commit('SET_CLASSIC_USER')
      }
    },
    update_nom_popup: ({commit}) => {
      sessionStorage.setItem('nom_popup', false)
      commit('UPDATE_NOM_POPUP')
    },
    update_naissance_popup: ({commit}) => {
      sessionStorage.setItem('naissance_popup', false)
      commit('UPDATE_NAISSANCE_POPUP')
    },
    update_gender: ({commit}, gender) => {
      if(gender=="FEMALE") {
        sessionStorage.setItem('gender', "FEMALE")
        commit('SET_GENDER_FEMALE')
      }
      else if(gender=="MALE") {
        sessionStorage.setItem('gender', "MALE")
        commit('SET_GENDER_MALE')
      }
    },
    update_nb_modules_completed: ({commit}, nbModules) => {
      sessionStorage.setItem('nb_modules_completed', nbModules)
      commit('UPDATE_NB_MODULES_COMPLETED', nbModules)
    },
    update_survey_agreement: ({commit}, agreementStatus) => {
      if(agreementStatus.agreement==true) {
        sessionStorage.setItem('accord_sondage', true)
        commit('SET_SURVEY_AGREEMENT')
      }
      else {
        sessionStorage.setItem('accord_sondage', false)
        commit('SET_SURVEY_DISAGREEMENT')
      }
      sessionStorage.setItem('date_accord_sondage', agreementStatus.agreementDate)
      commit('SET_SURVEY_AGREEMENT_DATE', agreementStatus.agreementDate)
    }
  },
  modules: {
  }
})
